<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">

    <div class="header mt-md-5">
      <div class="header-body">
        <div class="row align-items-center">
          <div class="col">

            <!-- Pretitle -->
            <h6 class="header-pretitle">
              Client Corporatif
            </h6>

            <!-- Title -->
            <h1 class="header-title">
              {{ getTitle() }}
            </h1>

          </div>
        </div> <!-- / .row -->
        <div class="row align-items-center">
          <div class="col">

            <!-- Nav -->
            <ul class="nav nav-tabs nav-overflow header-tabs">
              <li class="nav-item">
                <a [class.active]="this.menuService.menuItems['/clients/corporate/create'].isActive" class="nav-link"
                   routerLink="/clients/corporate/create">
                  Général
                </a>
              </li>

              <li class="nav-item">
                <a [class.active]="this.menuService.menuItems['/account/security'].isActive" class="nav-link"
                   routerLink="/account/security">
                  Test
                </a>
              </li>
            </ul>

          </div>
        </div>
      </div>
    </div>

    <!-- Form -->
    <form [formGroup]="form">

      <div class="row">
        <div class="col-12 col-md-6">
          <!-- Company Name -->
          <magieno-input-text-field [advancedFormControl]="getCompanyName()"></magieno-input-text-field>
        </div>
      </div> <!-- / .row -->

      <!-- Button -->
      <magieno-button [button]="form.getButton('SAVE')"></magieno-button>

    </form>

    <br><br>

  </div>
</div> <!-- / .row -->